import React from 'react';
/* eslint-disable react/no-danger */

const ModalBodyText = ({
  headline,
  line1,
  line2
}) => /*#__PURE__*/React.createElement("div", {
  className: "ebds-modal__content__body__text"
}, /*#__PURE__*/React.createElement("h3", null, headline), /*#__PURE__*/React.createElement("p", {
  dangerouslySetInnerHTML: {
    __html: line1
  }
}), line2 ? /*#__PURE__*/React.createElement("p", {
  dangerouslySetInnerHTML: {
    __html: line2
  }
}) : null);
export default ModalBodyText;